<ion-header>
    <ion-toolbar>
        <ion-buttons slot="start">
            <ion-back-button data-test="backButton"></ion-back-button>
        </ion-buttons>
        <ion-title data-test="title">Export</ion-title>
    </ion-toolbar>
</ion-header>

<ion-content>
    <ion-list-header color="secondary">
        Export data to json files
    </ion-list-header>
    
</ion-content>

<ion-footer>
    <ion-toolbar>
        <ion-button data-test="exportButton" color="primary" expand="full" (click)="onExportClick()">
            Export data to json
        </ion-button>
    </ion-toolbar>
</ion-footer>